/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Is_Data_ObservatoryInputs */

const fr_help_is_data_observatory = /** @type {(inputs: Help_Is_Data_ObservatoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un observatoire des données d'activité (historique, affectations).`)
};

const en_help_is_data_observatory = /** @type {(inputs: Help_Is_Data_ObservatoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An activity data observatory (history, assignments).`)
};

/**
* | output |
* | --- |
* | "An activity data observatory (history, assignments)." |
*
* @param {Help_Is_Data_ObservatoryInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const help_is_data_observatory = /** @type {((inputs?: Help_Is_Data_ObservatoryInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Is_Data_ObservatoryInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_help_is_data_observatory(inputs)
	return en_help_is_data_observatory(inputs)
});